import { rgba } from "polished";
import styled, { css } from "styled-components";

export const StyledAppTabsContainer = styled.div<{ $sticky?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: ${({ $sticky }) => ($sticky ? "visible" : "auto")};
  width: 100%;
`;

export const StyledAppTabsWrapper = styled.div<{ $sticky?: boolean }>`
  position: relative;
  width: 100%;

  ${({ $sticky, theme }) =>
    $sticky &&
    css`
      position: sticky;
      top: -25px;
      z-index: 100;
      background-color: ${theme.palette.background.secondary};
    `}
`;

export const StyledAppTabsList = styled.div`
  width: 100%;
  overflow: auto;
  background-color: ${(props) =>
    props.theme.palette.background.secondary} !important;
  border: 1px dashed ${({ theme }) => theme.palette.borderColor} !important;
  border-radius: ${({ theme }) => theme.cardRadius} !important;
  padding: 5px;
`;

export const StyledScrollGradient = styled.div<{ position: "left" | "right" }>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 30px;
  pointer-events: none;
  z-index: 10;

  ${({ position, theme }) => {
    if (position === "left") {
      return `
        left: 0;
        background: linear-gradient(
          to right,
          ${rgba(theme.palette.primary.main, 0.3)} 0%,
          transparent 100%
        );
      `;
    } else {
      return `
        right: 0;
        background: linear-gradient(
          to left,
          ${rgba(theme.palette.primary.main, 0.3)} 0%,
          transparent 100%
        );
      `;
    }
  }}
`;
